import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type CandidateListState = {
    searchInput: string;
    appliedSearch: string;
};

const initialState: CandidateListState = {
    searchInput: '',
    appliedSearch: '',
};

const candidateListSlice = createSlice({
    name: 'candidateList',
    initialState,
    reducers: {
        setCandidateSearch: (state, action: PayloadAction<{ searchInput: string; appliedSearch: string }>) => {
            state.searchInput = action.payload.searchInput;
            state.appliedSearch = action.payload.appliedSearch;
        },
        clearCandidateSearch: (state) => {
            state.searchInput = '';
            state.appliedSearch = '';
        },
    },
});

export const { setCandidateSearch, clearCandidateSearch } = candidateListSlice.actions;
export default candidateListSlice.reducer;
